// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2iVOu","icon":"SortAdornment_icon__3HG8W","up":"SortAdornment_up__2xsNH","down":"SortAdornment_down__1f9CG","active":"SortAdornment_active__2TSYs"};